import { postScore, postSinglePointScore, resendPostScoreInvite, deleteScore, acceptOrRejectResult, getPostableMatchups, getPostableMatch } from '../api';
import { getApiErrorMessage } from '../utils/apiError';
import { sportTypeIds } from '../utils/eventConstants';
import { showErrorPopup, showInfoToast, showSuccessPopup, showSuccessToast } from './notification-actions';

// add player to match
export function addPlayer({ key, player }) {
    return (dispatch) => {
        dispatch({
            type: 'POST_SCORE:ADD_PLAYER',
            key,
            player,
        });
    };
}

// post score to api
export const postUserScore = (values) => async (dispatch, getState, { mainApi }) => {
    let res;
    try {
        dispatch({ type: 'POST_SCORE:POST_SCORE_REQUEST' });
        dispatch({
            type: 'SPLASH_SHOW_SAVING',
            title: 'Saving Scores',
            description: 'Saving match scores',
        });
        if (values.sportTypeId === sportTypeIds.PICKLEBALL) {
            res = await postSinglePointScore(mainApi, values);
        } else {
            res = await postScore(mainApi, values);
        }
        if (res.data.error) {
            dispatch({
                type: 'POST_SCORE:POST_SCORE_FAILURE',
                res,
            });
            dispatch({
                type: 'SPLASH_HIDE',
            });
            dispatch(showErrorPopup({
                message: 'Error posting score.',
                error: res.data.error,
            }));
        } else {
            dispatch({
                type: 'SPLASH_HIDE',
            });
            dispatch({
                type: 'POST_SCORE:POST_SCORE_SUCCESS',
                data: res.data,
            });
        }
    } catch (err) {
        console.log(err);
        dispatch({
            type: 'POST_SCORE:POST_SCORE_FAILURE',
            err,
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });

        dispatch(showErrorPopup({
            message: getApiErrorMessage(err, 'Error posting score.'),
            error: err,
        }));

        throw err;
    }
};

// add round (match data) for posting eventscore
export function setRound(data) {
    return (dispatch) => {
        dispatch({
            type: 'POST_SCORE:SET_ROUND',
            data,
        });
    };
}

// send player posted result to post score for editing
export function setPlayerPostedMatch(data) {
    return (dispatch) => {
        dispatch({
            type: 'POST_SCORE:SET_PLAYER_POSTED_MATCH',
            data,
        });
    };
}

// resend invites for unfinalized results
export const resendInvites = (resultId) => async (dispatch, getState, { mainApi }) => {
    try {
        await resendPostScoreInvite(mainApi, resultId);
        dispatch(showErrorPopup({
            error: 'Invite email has been resent successfully!',
        }));
    } catch (err) {
        dispatch(showErrorPopup({
            message: `Resend Invites Failed`,
            error: err,
        }));
    }
};

// clear PostScore store
export function clearMatchData() {
    return (dispatch) => {
        dispatch({
            type: 'POST_SCORE:CLEAR',
        });
    };
}

// delete PostScore
export const deleteUserScore = (resultId, result = null) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await deleteScore(mainApi, resultId, result);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error deleting score.',
                error: res.data.error,
            }));
        } else {
            dispatch(showSuccessToast({
                message: 'Score Deleted Successfully!',
            }));
            dispatch({
                type: 'POST_SCORE:DELETE_SCORE_SUCCESS',
                data: { resultId },
            });
        }
    } catch (err) {
        dispatch(showErrorPopup({
            message: `Error deleting score.`,
            error: err,
        }));
    }
};

// Accept or Reject Player Posted Score
export const acceptOrRejectScore = (resultId, acceptOrReject, result = null) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch(showInfoToast({
            title: acceptOrReject === 'accept' ? 'Confirming Score...' : 'Denying Score...',
        }));
        const res = await acceptOrRejectResult(mainApi, resultId, acceptOrReject, result);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: acceptOrReject === 'accept' ? 'Error Accepting Score' : 'Error Rejecting Score',
                error: res.data.error,
            }));
        } else {
            dispatch(showSuccessPopup({
                message: acceptOrReject === 'accept' ? 'Score Accepted Successfully!' : 'Score Rejected Successfully!',
            }));
            dispatch({
                type: 'POST_SCORE:ACCEPT_REJECT_SCORE_SUCCESS',
                data: {
                    resultId,
                    acceptOrReject,
                    result: res.data,
                },
            });
        }
    } catch (err) {
        dispatch(showErrorPopup({
            message: acceptOrReject === 'accept' ? 'Error Accepting Score' : 'Error Rejecting Score',
            error: err,
        }));
    }
};

export const POST_SCORE_FETCH_POSTABLE_MATCHUPS = 'POST_SCORE:FETCH_POSTABLE_MATCHUPS';
export const POST_SCORE_FETCH_POSTABLE_MATCHUPS_SUCCESS = 'POST_SCORE:FETCH_POSTABLE_MATCHUPS_SUCCESS';
export const POST_SCORE_FETCH_POSTABLE_MATCHUPS_FAILURE = 'POST_SCORE:FETCH_POSTABLE_MATCHUPS_FAILURE';
export const getPostMatchups = (memberId, initialFetch) => async (dispatch, getState, { mainApi }) => {
    try {
        const { postScore: postScoreReducer } = getState();
        const { postableMatchups } = postScoreReducer;
        const skip = initialFetch ? 0 : postableMatchups.skip;
        const { top } = postableMatchups;

        dispatch({ type: POST_SCORE_FETCH_POSTABLE_MATCHUPS, initialFetch });
        getPostableMatchups(mainApi, memberId, skip, top)
            .then((result) => {
                dispatch({
                    type: POST_SCORE_FETCH_POSTABLE_MATCHUPS_SUCCESS,
                    data: result.data,
                    skip: skip + top,
                });
            })
            .catch((error) => {
                dispatch({ type: POST_SCORE_FETCH_POSTABLE_MATCHUPS_FAILURE });
                console.log('ERROR GETTING POSTABLE MATCHUPS', error);
            });
    } catch (error) {
        console.log('ERROR GETTING POSTABLE MATCHUPS', error);
    }
};

export const POST_SCORE_FETCH_MATCH = 'POST_SCORE:FETCH_MATCH';
export const POST_SCORE_FETCH_MATCH_SUCCESS = 'POST_SCORE:FETCH_MATCH_SUCCESS';
export const POST_SCORE_FETCH_MATCH_FAILURE = 'POST_SCORE:FETCH_MATCH_FAILURE';
export const getMatch = (memberId, matchId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: POST_SCORE_FETCH_MATCH });
        getPostableMatch(mainApi, memberId, matchId)
            .then((result) => {
                dispatch({
                    type: POST_SCORE_FETCH_MATCH_SUCCESS,
                    data: result.data,
                });
            })
            .catch((error) => {
                dispatch({ type: POST_SCORE_FETCH_MATCH_FAILURE });
                console.log('ERROR GETTING MATCH', error);
            });
    } catch (error) {
        console.log('ERROR GETTING MATCH', error);
    }
};
